import type { TCsvColumn } from '@cascade/core/utils';
import type {
  TConversationTranscript,
  TTranscriptCsvRow,
} from './useConversationsExport.types.ts';

export const transcriptCsvColumns: TCsvColumn<TTranscriptCsvRow>[] = [
  'conversation_id',
  'title',
  'conversation_date',
  'message_id',
  'message_date',
  'sender',
  'message',
];

export const buildTranscriptCsvRows = (
  transcripts: TConversationTranscript[],
): TTranscriptCsvRow[] =>
  transcripts.flatMap(({ conversation, messages }) =>
    messages.map((message) => ({
      conversation_id: conversation.conversation_id,
      title: conversation.title,
      conversation_date: conversation.date,
      message_id: message.id,
      message_date: message.date ?? '',
      sender: message.sender ?? '',
      message: message.message ?? '',
    })),
  );
